module.exports = __webpack_public_path__ + "img/wedcr4.711cbdde.jpg";